export default "__VITE_ASSET__CztH0gTx__"